import axios from '@/axios';
import coreIAMUrl from '@/apis/coreIAM'

export default {
    fetchAll() {
        return axios.get(`${coreIAMUrl}/admin/service-accounts`);
    },
    fetchOne(uuid) {
        return axios.get(`${coreIAMUrl}/admin/service-accounts/${uuid}`);
    },
    createServiceAccount(id, name, description) {
        return axios.post(`${coreIAMUrl}/admin/service-accounts`, {
            application_id: id,
            application_name: name,
            application_description: description,
        });
    },
    updateServiceAccount(uuid, id, name, description) {
        return axios.patch(`${coreIAMUrl}/admin/service-accounts/${uuid}`, {
            application_id: id,
            application_name: name,
            application_description: description,
        });
    },
    deleteServiceAccount(uuid) {
        return axios.delete(`${coreIAMUrl}/admin/service-accounts/${uuid}`)
    },
    getServiceAccountSecret(uuid) {
        return axios.post(`${coreIAMUrl}/admin/service-accounts/${uuid}/retrieve-secret`);
    },
    listServiceAccountRoles(uuid) {
        return axios.get(`${coreIAMUrl}/admin/service-accounts/${uuid}/service-account-roles`);
    },
    listServiceAccountAvailableRoles(uuid) {
        return axios.get(`${coreIAMUrl}/admin/service-accounts/${uuid}/service-account-roles/available`);
    },
    addServiceAccountRoles(uuid, roles) {
        return axios.post(`${coreIAMUrl}/admin/service-accounts/${uuid}/service-account-roles/add`, roles);
    },
    removeServiceAccountRoles(uuid, roles) {
        return axios.post(`${coreIAMUrl}/admin/service-accounts/${uuid}/service-account-roles/remove`, roles);
    },
    getDefaultScopes(uuid) {
        return axios.get(`${coreIAMUrl}/admin/apis/${uuid}/default-scopes`)
    },
    addDefaultScope(uuid, scopeUuid) {
        return axios.post(`${coreIAMUrl}/admin/apis/${uuid}/add-default-scopes`, {
            scope_uuid: scopeUuid
        })
    },
    removeDefaultScope(uuid, scopeUuid) {
        return axios.post(`${coreIAMUrl}/admin/apis/${uuid}/remove-default-scopes`, {
            scope_uuid: scopeUuid
        })
    },
    getOptionalScopes(uuid) {
        return axios.get(`${coreIAMUrl}/admin/apis/${uuid}/optional-scopes`)
    },
    addOptionalScope(uuid, scopeUuid) {
        return axios.post(`${coreIAMUrl}/admin/apis/${uuid}/add-optional-scopes`, {
            scope_uuid: scopeUuid
        })
    },
    removeOptionalScope(uuid, scopeUuid) {
        return axios.post(`${coreIAMUrl}/admin/apis/${uuid}/remove-optional-scopes`, {
            scope_uuid: scopeUuid
        })
    },
}